import { LinkMapper } from '@sunrise/shared'
import { Cms } from '@sunrise/types'
import { NewsItem, NewsType } from './newsService.types'

export function renderDetailUrl(newsItem: NewsItem, locationId: string, globalLinks: Cms.GlobalLinks): string {
    const globalLinkId = newsItem.type === NewsType.POLICE ? 'newsDetailPolice' : 'newsDetailFire'
    const basicGlobalLink = globalLinks[globalLinkId]

    if (!basicGlobalLink) {
        return ''
    }

    return LinkMapper.replaceWildcards(basicGlobalLink.replace(locationId, newsItem?.locationId || ''), [
        newsItem.id.toString(),
    ])
}
